@for (col of columns(); track col.field ?? col.header) {
  <th pFrozenColumn
      [frozen]="col.frozen && !viewPortService.isMobile"
      [class]="col.class"
      [pSortableColumn]="col.field ?? ''"
      [pSortableColumnDisabled]="!col.field">
    @if (col.type === 'checkbox') {
      <p-tableHeaderCheckbox />
    } @else {
      {{ col.header }}
      @if (col.tooltip) {
        <i class="icon icon-info ic-primary ml-5" [matTooltip]="col.tooltip"></i>
      }
      @if (col.field) {
        <p-columnFilter [type]="col.type ?? 'text'"
                        [field]="col.field"
                        display="menu"
                        [matchMode]="col.matchMode" />
        <p-sortIcon [field]="col.field" />
      }
    }
  </th>
}
